import { Alert } from 'antd';

export type RiskBannerSeverity = 'critical' | 'high' | 'info';

interface RiskBannerWebProps {
  severity: RiskBannerSeverity;
  title: React.ReactNode;
  /** Optional detail lines rendered under the title. */
  messages?: string[];
  /** Optional rich body (rendered after `messages`). */
  children?: React.ReactNode;
  className?: string;
}

/**
 * Severity-anchored risk banner — same semantics as ssp-key's RiskBanner
 * (critical = red, high = amber, info = neutral), built on antd Alert so it
 * inherits the token theme. ADVISORY presentation only: it never gates or
 * disables the sign/approve controls by itself.
 */
export function RiskBannerWeb({
  severity,
  title,
  messages,
  children,
  className,
}: RiskBannerWebProps) {
  const type = severity === 'critical' ? 'error' : severity === 'high' ? 'warning' : 'info';
  const hasBody = (messages && messages.length > 0) || children != null;
  return (
    <Alert
      type={type}
      showIcon
      title={title}
      className={className}
      data-testid={`risk-banner-${severity}`}
      description={
        hasBody ? (
          <>
            {messages && messages.length > 0 && (
              <ul className="risk-banner-messages">
                {messages.map((message, index) => (
                  <li key={index}>{message}</li>
                ))}
              </ul>
            )}
            {children}
          </>
        ) : undefined
      }
    />
  );
}

export default RiskBannerWeb;
